const tabs = {
  RollbackPlanList: () => import('@/views/management/Resignation/rollback-plan'),
  RollbackPlanRegister: () => import('@/views/management/Resignation/rollback-plan/rollback-plan-register'),
  RollbackPlanFollowRegister: () => import('@/views/management/Resignation/rollback-plan/rollback-follow-register'),
  RollbackPlanView: () => import('@/views/management/Resignation/rollback-plan/rollback-plan-view')
}

const state = {
  currentRollbackPlanTab: tabs.RollbackPlanList,
  tabs,
  incompleteResignationRequest: false
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentRollbackPlanTab = state.tabs[tab]
  },
  SET_RESIGNATION_REQUEST_FIELDS_STATUS: (state, status) => {
    state.incompleteResignationRequest = status
  }
}

const actions = {
  setCurrentRollbackPlanTab({ commit }, tab) {
    commit('SET_TABS', tab)
  },
  setResignationRequestFieldsStatus({ commit }, status) {
    commit('SET_RESIGNATION_REQUEST_FIELDS_STATUS', status)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
